import { LoadableRoute } from 'routes/utils/loadable';

export const IntegrationsContainer = LoadableRoute({
  loader: () =>
    import(/* webpackChunkName: "IntegrationsRoot" */ './Integrations'),
});
